import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getProductsByLocation, getProductsByEntity, clearProductsBy } from '../../../../../actions/inventoryActions'
import ProductLocationsListView from '../../../../containers/Inventory/InventoryLocations/ProductLocationsList/ProductLocationsList' 
import { useHistory } from "react-router-dom";


/**
 * [ProductLocationsList: component to get the products in inventory of an Entity or Location]
 * @param  match  inventoryType and id
 * @return string  With format time
 */

const ProductLocationsList = ({match}) => {
  const history = useHistory();
    let auxFunction;
    let inventoryType = match.params.inventoryType;
    let locationId = match.params.locationId;
    let locationName = match.params.locationName;
    const limitInventoryItems = 100;

    const [skip, setSkip] = useState(0);
    const [search, setSearch] = useState('')

    const onClickRow = (inventoryType, productId) => {

      if(inventoryType=='Location')
      {
        history.push(`/Admin/Inventory/BatchesLocationsList/Location/${ productId }/${ locationId }/${ locationName } `);
      }
  
      else if(inventoryType=='Entity')
      {
        history.push(`/Admin/Inventory/BatchesLocationsList/Entity/${ productId }/${ locationId }/${ locationName }`);
      }
    }

    const dispatch = useDispatch();
    const { productsByLocation } = useSelector(state => state.inventory);

    useEffect(() => {
        productsByLocation.length=0;
        switch(inventoryType){
          case 'Location':
            auxFunction = dispatch(getProductsByLocation(locationId, limitInventoryItems, skip));
            break;
    
          case 'Entity':
            auxFunction = dispatch(getProductsByEntity(locationId, limitInventoryItems, skip));
            break;
          
          default:
            console.log()
      }
      
      return () => {

        dispatch(clearProductsBy())

       }
      }, [search]);

  return (
    <ProductLocationsListView 
      inventoryProducts = {productsByLocation}
      skip = {skip}
      setSkip = {setSkip}
      limit = {limitInventoryItems}
      setSearch = {setSearch}
      onClickRow = {onClickRow}
      locationName = {locationName}
      inventoryType = {inventoryType}
    />
  )
}

export default ProductLocationsList